import { useUiFromSpecContext } from '../EditorContextProvider'
import { evaluateCondition } from './utils/evaluateCondition'

export const RenderView = (props: any) => {
  const { item, form } = props
  const { fieldConfig, editor, setEditor } = useUiFromSpecContext()

  if (!fieldConfig) return null

  // Get all form field values using React Hook Form's watch method
  const watchAllFields = form?.watch()
  // Check if this form item has a conditional logic expression defined
  if (item?.logic?.expression) {
    // Evaluate the condition expression against current form values
    const conditionResult = evaluateCondition(watchAllFields, item?.logic?.expression)
    // If we're not in editor mode and the condition evaluates to true, don't render this component
    if (!editor && conditionResult) {
      return null
    }
  }

  const component = fieldConfig.find((config) => config.ui_type === item.ui_type)
  if (component) {
    const Component = component.renderComponent
    return <Component key={item.id} {...props} editor={editor} setEditor={setEditor} />
  } else {
    console.error('Component not found for ui_type:', item.ui_type)
    return null
  }
}
